import * as actionTypes from "../actions/candidat/actionTypes";
import { LOGOUT_REQUEST } from "../actions/auth/actionTypes";
import { combineReducers } from "redux";

const initialState = {
  langue: process.env.REACT_APP_DEFAULT_LANG,
};

export const candidat = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CANDIDAT_SUCCESSFUL:
      return {
        ...state,
        ...action.response
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        id: undefined,
        prenom: undefined,
        nom: undefined,
        date_naissance: undefined,
        sexe: undefined,
      };
    default:
      return state;
  }
};
const isFetching = (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CANDIDAT_REQUEST:
      return true;
    case actionTypes.FETCH_CANDIDAT_SUCCESSFUL:
    case actionTypes.FETCH_CANDIDAT_FAILURE:
      return false;
    default:
      return state;
  }
};
const isUpdating = (state = false, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CANDIDAT_REQUEST:
      return true;
    case actionTypes.UPDATE_CANDIDAT_SUCCESSFUL:
    case actionTypes.UPDATE_CANDIDAT_FAILURE:
      return false;
    default:
      return state;
  }
};
const error = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CANDIDAT_SUCCESSFUL:
    case actionTypes.FETCH_CANDIDAT_REQUEST:
    case actionTypes.UPDATE_CANDIDAT_SUCCESSFUL:
    case actionTypes.UPDATE_CANDIDAT_REQUEST:
      return null;
    case actionTypes.FETCH_CANDIDAT_FAILURE:
    case actionTypes.UPDATE_CANDIDAT_FAILURE:
      return action.error;
    default:
      return state;
  }
};

const candidatStatus = combineReducers({ isFetching, isUpdating, error });
export default candidatStatus;
export const getError = (state) => state.error;
export const getIsFetching = (state) => state.isFetching;
export const getIsUpdating = (state) => state.isUpdating;
